import trigger from './customEvent';

//お気に入り一覧表示
export default function (cal) {
	const siteurl = document.getElementById('js-page-wrapper').getAttribute('data-siteurl');
	const putEl = document.getElementById('js-bookmark');
	let bookmark = localStorage.getItem("bookmark");
	if(bookmark) {
		bookmark = JSON.parse(bookmark);
		const ids = bookmark.ids.join(',');
		axios({
			method: 'get',
			url: siteurl + '/bookmarkapi/',
			responseType:'document',
			params: {
				ids: ids
			},
		})
			.then(function (response) {
				const items = response.data.querySelectorAll('#bookmark-list li');
				if(items.length <= 0) {
					putEl.innerHTML = '<p class="u-ta-center">お気に入りに登録されたレシピはありません</p>';
				}
				[].forEach.call(items, function(item) {
					let date = item.getAttribute('data-date');
							date = date.slice(-4);
							date = Number(date);
							if(date <= 531 && date >= 301) {
								item.classList.add('spring');
							}
							else if(date <= 831 && date >= 601) {
								item.classList.add('summer');
							}
							else if(date <= 1130 && date >= 901) {
								item.classList.add('autumn');
							}
							else {
								item.classList.add('winter');
							}
					putEl.appendChild(item);
				});
				trigger(window, 'loadingEnd');
				trigger(putEl, 'bookmarkReady');
			})
			.catch(function (error) {
				console.log(error);
				trigger(window, 'loadingEnd');
			})
			.then(function () {
			}
		);
	} else {
		trigger(window, 'loadingEnd');
		putEl.innerHTML = '<p class="u-ta-center">お気に入りに登録されたレシピはありません</p>';
	}
}
